import { useDispatch, useSelector } from 'react-redux';
import { useState } from 'react';
import _isEmpty from 'lodash/isEmpty';
import _isNaN from 'lodash/isNaN';
import _isNil from 'lodash/isNil';
import _defaultTo from 'lodash/defaultTo';
import { ErrorToast, MultipleErrorToast, notifySuccess } from '../../utils/Utils';
import {
  setExercise,
  setExerciseCategories,
  setExerciseCategory,
  showProgress,
} from '../../../redux/actions/DealershipActions';
import { apiEndpoints } from '../../../constants/apiEndpoints';
import service from '../../../apis/service';
import { INITIAL_EXERCISE_INFO } from '../contants';

export const useExercise = () => {
  const dispatch = useDispatch();

  const [step, setStep] = useState(1);
  const [isOpenPopup, setIsOpenPopup] = useState(false);
  const [imageData, setImageDataa] = useState();
  const [thumbnail, setThumbnaill] = useState('');
  const [exerciseInfo, setExerciseInfo] = useState(INITIAL_EXERCISE_INFO);
  const [types, setTypes] = useState([]);
  const [AICharacters, setAICharacters] = useState([]);
  const [journeys, setJourneys] = useState([]);
  const [plansList, setPlansList] = useState([]);
  const [collectionList, setCollectionList] = useState([]);

  const selectedCat = useSelector((state) => state.aiRoleplayData.selectedCategory || {});
  const selectedExercise = useSelector((state) => state.aiRoleplayData.selectedExercise || {});

  const handleImageUpload = (e) => {
    const filesData = e.target.files[0];
    setImageDataa(filesData);
    const reader = new global.FileReader();
    reader.onload = (ev) => {
      setThumbnaill(ev.target.result);
    };
    reader.readAsDataURL(e.target.files[0]);
  };

  const fetchExercise = async () => {
    dispatch(showProgress(true));

    try {
      const res = await service.get(apiEndpoints.AI_EXERCISE.replace('ID', selectedCat.id));
      dispatch(setExercise(res));
    } catch (error) {
      ErrorToast(error);
    }
    dispatch(showProgress(false));
  };

  const fetchAllCategories = async () => {
    dispatch(showProgress(true));
    try {
      const res = await service.get(apiEndpoints.AI_EXERCISE_CATEGORIES);
      dispatch(setExerciseCategories(res));
      const selected = res?.find((i) => i.id === selectedCat.id) || {};
      handleListItemClick(selected);
      fetchExercise();
    } catch (error) {
      ErrorToast(error);
    }
    dispatch(showProgress(false));
  };

  const handleListItemClick = async (data = {}) => {
    dispatch(showProgress(true));

    if (!_isEmpty(data)) {
      dispatch(setExerciseCategory(data));
    }
    dispatch(showProgress(false));
  };

  const handleValidation = (form, overView, img, journeyIds, isEdit) => {
    let isValid = true;
    const errors = [];
    if (step === 1) {
      const { name, type, level, timeLimit, userRole, botRole, botCharacter, scenarioIntro, callTransfer, botIntro } =
        form;
      if (!name || name.trim() === '') {
        isValid = false;
        errors.push('Please enter Exercise name');
      }
      if (!isEdit && !img) {
        isValid = false;
        errors.push('Please select thumbnail image');
      }
      if (!type) {
        isValid = false;
        errors.push('Please select Exercise type');
      }
      if (!level) {
        isValid = false;
        errors.push('Please select Exercise level');
      }
      if (!timeLimit) {
        isValid = false;
        errors.push('Please enter time limit');
      }
      if (!userRole || userRole.trim() === '') {
        isValid = false;
        errors.push('Please enter user role');
      }
      if (!botRole || botRole.trim() === '') {
        isValid = false;
        errors.push('Please enter bot role');
      }
      if (!botCharacter) {
        isValid = false;
        errors.push('Please select bot character');
      }
      overView?.forEach((over, i) => {
        if (!over.text || over.text?.trim() === '') {
          isValid = false;
          errors.push(`Please enter overview screen ${i + 1}`);
        }
      });

      if (!scenarioIntro || scenarioIntro.trim() === '') {
        isValid = false;
        errors.push('Please enter scenario introduction');
      }
      if (!callTransfer || callTransfer.trim() === '') {
        isValid = false;
        errors.push('Please enter call transfer text');
      }
      if (!botIntro || botIntro.trim() === '') {
        isValid = false;
        errors.push('Please enter bot introduction');
      }
    }

    if (step === 2) {
      const { goal, context, instruction, reportingParameters, passingPercentage } = form;
      if (!goal || goal.trim() === '') {
        isValid = false;
        errors.push('Please enter goal of the bot');
      }

      if (!context || context.trim() === '') {
        isValid = false;
        errors.push('Please enter context for the bot');
      }
      if (!instruction || instruction.trim() === '') {
        isValid = false;
        errors.push('Please enter instruction');
      }

      // Validate reportingParameters
      if (!reportingParameters || reportingParameters.length !== 3) {
        isValid = false;
        errors.push('Please configure all 3 scoring parameters');
      } else {
        reportingParameters.forEach((param, index) => {
          const nameLength = param.name?.trim().length ?? 0;
          const descriptionLength = param.description?.trim().length ?? 0;
          if (!param.name || param.name.trim() === '') {
            isValid = false;
            errors.push(`Please enter name for  parameter ${index + 1}`);
          }
          if (!param.description || param.description.trim() === '') {
            isValid = false;
            errors.push(`Please enter description for  parameter ${index + 1}`);
          }

          if (nameLength > 100) {
            isValid = false;
            errors.push(`Character limit (100) exceeded for name parameter ${index + 1}`);
          }

          if (descriptionLength > 250) {
            isValid = false;
            errors.push(`Character limit (250) exceeded for description parameter ${index + 1}`);
          }
          const validInstructions = Array.isArray(param.instructions)
            ? param.instructions.filter((inst) => inst && inst.trim() !== '')
            : [];
          if (!validInstructions || validInstructions.length === 0) {
            isValid = false;
            errors.push(`Please enter scoring logic for  parameter ${index + 1}`);
          }
        });
      }

      // Validate passingPercentage: if not null, must be between 0-100
      if (!_isNil(passingPercentage) && passingPercentage !== '') {
        const percentage = Number(passingPercentage);
        if (_isNaN(percentage)) {
          isValid = false;
          errors.push('Passing percentage must be a valid number');
        } else if (percentage < 0 || percentage > 100) {
          isValid = false;
          errors.push('Passing percentage must be between 0 and 100');
        }
      }
    }

    if (step === 3) {
      if (!journeyIds?.length) {
        isValid = false;
        errors.push('Please select atleast one journey ');
      }
    }

    if (errors.length !== 0) {
      MultipleErrorToast(errors);
    }
    return isValid;
  };

  const createExercise = async (form, overView, img, journeyIds, setIsOpen) => {
    const data = new global.FormData();
    if (form.id) {
      data.append('id', form.id);
    }
    data.append('topicId', selectedCat?.id);
    data.append('name', form.name);
    data.append('exerciseTypeId', form.type);
    data.append('level', form.level);
    data.append('aiCharacterId', form.botCharacter);
    data.append('callTransferText', form.callTransfer);
    data.append('goal', form.goal);
    data.append('instructions', form.instruction);
    data.append('contextForBot', form.context);
    data.append('botIntroduction', form.botIntro);
    data.append('timeLimitInMinutes', form.timeLimit);
    data.append('introduction', form.scenarioIntro);
    data.append('roleOfLLM', form.botRole);
    data.append('roleOfUser', form.userRole);
    data.append('showTranscript', form.showTranscript);

    // arrays
    overView?.map((over) => data.append('scenarioIntro', over.text));

    // Include key if it exists (for edit mode)
    const reportingParameters = (form.reportingParameters || []).map((param) => ({
      name: param.name || '',
      description: param.description || '',
      instructions: Array.isArray(param.instructions)
        ? param.instructions.filter((inst) => inst && inst.trim() !== '')
        : [],
      ...(param.key && { key: param.key }),
    }));

    data.append('reportingParameters', JSON.stringify(reportingParameters));

    const passingPercentageValue = _defaultTo(form.passingPercentage, '');

    data.append('passingPercentage', passingPercentageValue);

    journeyIds?.map((id) => data.append('journeys', id));

    if (img) {
      data.append('thumbnail', img);
    }

    dispatch(showProgress(true));
    try {
      await service.post(apiEndpoints.AI_CREATE_EXERCISE, data);
      notifySuccess('Exercise created successfully');
      setIsOpenPopup(false);
      setIsOpen(false);
      fetchAllCategories();
      resetAll();
    } catch (error) {
      ErrorToast(error);
    }
    dispatch(showProgress(false));
  };

  const deleteExercise = async () => {
    dispatch(showProgress(true));
    try {
      await service.delete(apiEndpoints.AI_DELETE_EXERCISE.replace('ID', selectedExercise.id));
      notifySuccess('Exercise deleted successfully');
      fetchAllCategories();
    } catch (error) {
      ErrorToast(error);
    }
    dispatch(showProgress(false));
  };
  const getExerciseInfo = async (setForm, setOverView, setThumbnail, setJourneyIds) => {
    dispatch(showProgress(true));
    try {
      const res = await service.get(apiEndpoints.AI_GET_EXERCISE_INFO.replace('ID', selectedExercise.id));

      // Convert reportParameters to reportingParameters format
      const reportingParameters = (res.reportParameters || []).map((param) => ({
        name: param.name || '',
        description: param.description || '',
        instructions: Array.isArray(param.instructions) ? param.instructions : [],
        ...(param.key && { key: param.key }),
      }));

      // Ensure we have exactly 3 parameters
      while (reportingParameters.length < 3) {
        reportingParameters.push({ name: '', description: '', instructions: [] });
      }

      const payload = {
        id: res.id,
        name: res.name,
        type: res.aiRolePlayExerciseType,
        level: res.level,
        desc: '',
        timeLimit: res.timeLimitInMinutes,
        userRole: res.roleOfUser,
        botRole: res.roleOfLLM,
        botCharacter: res.aiCharacterId,
        scenarioIntro: res?.introduction,
        callTransfer: res.callTransferText,
        botIntro: res.botIntroduction?.text,
        goal: res.goal,
        context: res.contextForBot,
        instruction: res.instructions,
        showTranscript: res.showTranscript,
        reportingParameters: reportingParameters.slice(0, 3),
        passingPercentage: res.passingPercentage,
      };
      setThumbnail(res.thumbnail || '');
      setJourneyIds(res.journeys || []);
      setForm(payload);
      setOverView(res?.scenarioIntro);
    } catch (error) {
      ErrorToast(error);
    }
    dispatch(showProgress(false));
  };

  const handleChange = (e, type) => {
    const input = e.target.value;
    setExerciseInfo((pre) => ({
      ...pre,
      [type]: input,
    }));
  };

  const getTypes = async () => {
    dispatch(showProgress(true));
    try {
      const res = await service.get(apiEndpoints.AI_EXERCISE_TYPES);
      setTypes(res);
    } catch (error) {
      ErrorToast(error);
    }
    dispatch(showProgress(false));
  };

  const getAICharacters = async () => {
    dispatch(showProgress(true));
    try {
      const res = await service.get(apiEndpoints.AI_CHARACTERS);
      setAICharacters(res);
    } catch (error) {
      ErrorToast(error);
    }
    dispatch(showProgress(false));
  };

  const getFilteredJourney = async (searchQuery = '', plans = [], collections = []) => {
    dispatch(showProgress(true));
    const payload = {
      searchQuery,
      plans,
      collections,
    };
    try {
      const res = await service.post(apiEndpoints.AI_FILTERED_JOURNEY, payload);
      setJourneys(res);
    } catch (error) {
      ErrorToast(error);
    }
    dispatch(showProgress(false));
  };

  const getPlan = async () => {
    dispatch(showProgress(true));
    try {
      const res = await service.get(apiEndpoints.GET_PLANS);
      setPlansList(res);
    } catch (error) {
      ErrorToast(error);
    }
    dispatch(showProgress(false));
  };

  const getCollections = async () => {
    dispatch(showProgress(true));
    try {
      const res = await service.get(apiEndpoints.JOURNEY_COLLECTION_LIST);
      setCollectionList(res);
    } catch (error) {
      ErrorToast(error);
    }
    dispatch(showProgress(false));
  };

  const handleNext = (form, overView, img, journeyIds, setIsOpen, isEdit) => {
    const isValid = handleValidation(form, overView, img, journeyIds, isEdit);
    if (!isValid) return;
    if (step === 3) {
      createExercise(form, overView, img, journeyIds, setIsOpen);
    } else {
      setStep((pre) => pre + 1);
    }
  };

  const resetAll = () => {
    setStep(1);
  };

  return {
    step,
    setStep,
    handleNext,
    isOpenPopup,
    setIsOpenPopup,
    thumbnail,
    imageData,
    handleImageUpload,
    deleteExercise,
    fetchExercise,
    selectedExercise,
    setExerciseInfo,
    handleChange,
    exerciseInfo,
    getExerciseInfo,
    getTypes,
    types,
    getAICharacters,
    AICharacters,
    getFilteredJourney,
    getPlan,
    getCollections,
    journeys,
    plansList,
    collectionList,
    resetAll,
  };
};
